import { Apple, Download, Globe, Smartphone } from "lucide-react";
import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { useI18n } from "@/i18n/LanguageContext";

export const AppInstall = () => {
  const { t } = useI18n();
  const [deferredPrompt, setDeferredPrompt] = useState<any>(null);

  useEffect(() => {
    const handler = (e: Event) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleAndroidInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    await deferredPrompt.userChoice;
    setDeferredPrompt(null);
  };

  const platforms = [
    {
      key: "android",
      icon: Smartphone,
      name: "Android",
      desc: t.contact.app.androidAlert,
      action: deferredPrompt ? (
        <Button size="sm" className="h-8 shrink-0 px-3 text-xs" onClick={handleAndroidInstall}>
          {t.contact.app.installShort}
          <Download className="ml-1.5 h-3.5 w-3.5" aria-hidden="true" />
        </Button>
      ) : undefined,
    },
    {
      key: "ios",
      icon: Apple,
      name: "iOS",
      desc: t.contact.app.iosAlert,
    },
    {
      key: "web",
      icon: Globe,
      name: "Web",
      desc: t.contact.app.webInstruction,
    },
  ];

  return (
    <div className="text-left">
      <p className="mb-2 text-xs font-bold uppercase tracking-wide text-foreground">{t.contact.app.title}</p>
      <p className="mb-3 text-sm leading-6 text-muted-foreground">{t.contact.app.text}</p>
      <ul className="space-y-2">
        {platforms.map(({ key, icon: Icon, name, desc, action }) => (
          <li
            key={key}
            className="flex items-start gap-3 rounded-lg border border-border/60 bg-background/40 p-3"
          >
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-secondary text-primary">
              <Icon className="h-4.5 w-4.5" aria-hidden="true" />
            </span>
            <span className="min-w-0 flex-1">
              <span className="block text-sm font-semibold text-foreground">{name}</span>
              <span className="mt-0.5 block text-xs leading-5 text-muted-foreground">{desc}</span>
            </span>
            {action}
          </li>
        ))}
      </ul>
    </div>
  );
};
